export default {
    it: {
        "base_select": "Lista opzioni",
        "base_error": "Errore!",

        "contact_times": "Orario preferito di contatto",
        "contact_times_error": "Per favore seleziona un orario di contatto",

        "pgpf": "Stai operando come persona fisica o come persona giuridica?",
        "pgpf_error": "Per favore seleziona un valore",

        "legal": "Stai presentando una richiesta di informazioni di carattere giuridico-normativo?",
        "legal_error": "Per favore seleziona un valore",

        "persona": "Tipologia Utente",
        "persona_error": "Per favore seleziona un valore",

        "elenco_registro": "Elenco/Registro",
        "elenco_registro_error": "Per favore seleziona un valore",

        "job": "Seleziona a quale tra queste categorie appartieni",
        "job_error": "Per favore seleziona un valore",

        "document_type_1": "Tipo documento 1",
        "document_type_1_error": "Per favore seleziona un valore",

        "document_type_2": "Tipo documento 2",
        "document_type_2_error": "Per favore seleziona un valore",


        "area_preferenza": "Area preferenza",
        "area_preferenza-field-not-ok": "Per favore seleziona un'area di preferenza",
    },
    en: {
        "base_select": "Option list",
        "base_error": "Error!",

        "persona": "User type",
        "persona_error": "Please select a value",

        "contact_times": "Preferred contact time",
        "contact_times_error": "Please choose a contact time",

        "pgpf": "Are you operating as a natural person or as a legal person?",
        "pgpf_error": "Please select a value",

        "legal": "Are you submitting a request for legal-regulatory information?",
        "legal_error": "Please select a value",

        "persona": "Physical / Legal Person",
        "persona_error": "Please select a value",

        "elenco_registro": "List / Register",
        "elenco_registro_error": "Please select a value",

        "job": "Select which of these categories you belong to",
        "job_error": "Please select a value",

        "document_type_1": "Document type 1",
        "document_type_1_error": "Please select a value",

        "document_type_2": "Document type 2",
        "document_type_2_error": "Please select a value",
       
        "area_preferenza": "Preference Area",
        "area_preferenza-field-not-ok": "Please choose a Preference Area",
    }
}